import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchUpdatePrivateProjectBankItemAsDeleted } from 'scenes/ProjectBank/services/private-project-bank/patchUpdatePrivateProjectBankItemAsDeleted.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const deletePrivateProjectBankItem = createAsyncThunk(
  'project-bank/deletePrivateProjectBankItem',
  async (privateFileItemId, { getState }) => {
    const projectId = selectSelectedProjectId(getState());

    const response = await patchUpdatePrivateProjectBankItemAsDeleted(
      projectId,
      privateFileItemId
    );

    return response;
  }
);
